/**
 * GiftProductDetailContainer
 * --
 */
import React from 'react';
import GiftProductDetailPresenter from './GiftProductDetailPresenter';

const GiftProductDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <GiftProductDetailPresenter />
    </>
  );
};

export default GiftProductDetailContainer;
